import baseUrl from "services/api";
import { FindClientsListParms, FindInactiveClientsParms, ResponseFindClientsListTypes, ResponseInactiveClientsTypes } from "types/clientsTypes";

interface BuscaClientesProps {
  page: number;
  nome?: string;
  documento?: string;
  cidade?: string;
}

interface BuscaClientesInativosTypes {
  page: number;
  dias: number;
  nome?: string;
}

export async function BuscaCidadeClientes() {
  const response = await baseUrl.get(`clientes/cidadesEmpressas`);

  return response.data;
}

export async function BuscaCidades() {
  const response = await baseUrl.get(`clientes/cidades`);

  return response.data;
}

export async function BuscaClientes(props: BuscaClientesProps) {
  let nome = props.nome ?? "";
  let documento = props.documento ?? "";
  let cidade = props.cidade ?? "";

  const response = await baseUrl.get(
    `clientes/clientes?page=${props.page}&nome=${nome}&documento=${documento}&cidade=${cidade}`
  );

  return response.data;
}

export async function FindInactiveClientsFunction(
  props: FindInactiveClientsParms
): Promise<PaginateProps<ResponseInactiveClientsTypes[]>> {
  const response = await baseUrl.get(`clientes/clientes_inativos`, {
    params: props,
  });

  return response.data;
}

export async function BuscaClientesInativos(props: BuscaClientesInativosTypes) {
  const response = await baseUrl.get(`clientes/clientes_inativos`, {
    params: props,
  });

  return response.data;
}

export async function FindClientsListByParmFunction(
  parms: FindClientsListParms
): Promise<PaginateProps<ResponseFindClientsListTypes[]>> {
  const response = await baseUrl.get(
    `clientes/clientes`,
    {
      params: parms,
    }
  );

  return response.data;
}
